var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory-list tab-table p-2"},[_c('InventoryTable',{attrs:{"exclude-search-fields":['receipt'],"show-qr-codes-export":"","showExportAllImages":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }